let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gqzPx")).then(() => parcelRequire('9EUOa'));